import { createFileRoute } from "@tanstack/react-router"

import { QueryState } from "../components/layout/query-state"
import { ScheduleJobDetail } from "../components/settings/schedule-job-detail"
import { useScheduledJobs } from "../services/use-scheduled-jobs"

function JobPage() {
  const { jobId } = Route.useParams()
  const query = useScheduledJobs()
  const job = query.data?.find((candidate) => candidate.id === jobId)
  return (
    <QueryState
      isLoading={query.isLoading}
      error={query.error}
      isEmpty={!job}
      emptyMessage="This scheduled job was not found."
    >
      {job ? <ScheduleJobDetail job={job} /> : null}
    </QueryState>
  )
}
export const Route = createFileRoute("/settings/schedules/$jobId")({ component: JobPage })
